module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div tabindex="0" class="apexchat_overlay_content" id="opt_in_consent">\r\n    <div style="font-size: 14px; color: #fff">\r\n		' +
((__t = (text )) == null ? '' : __t) +
'\r\n	</div>\r\n    <div style="margin-top: 10px;margin-bottom: 10px;">\r\n        <button class="livechat_optin_agree livechat_button livechat_button_large livechat_primary_button">\r\n			' +
((__t = ( acceptText )) == null ? '' : __t) +
'\r\n		</button>\r\n        <button class="livechat_optin_change livechat_button livechat_button_large livechat_primary_button">\r\n           ' +
((__t = ( changeText )) == null ? '' : __t) +
'\r\n	</button>\r\n        <button class="livechat_optout livechat_button livechat_button_text livechat_button_text_dull">\r\n			' +
((__t = ( rejectText )) == null ? '' : __t) +
'\r\n		</button>\r\n    </div>\r\n</div>';

}
return __p
}